export enum ButtonColor {
  None = '',
  Primary = 'primary',
  Accent = 'accent',
  Warning = 'warn',
  Error = 'error'
}

export enum ButtonStyle {
  Normal = 'mat-button',
  Flat = 'mat-flat-button',
  Icon = 'mat-icon-button',
  Raised = 'mat-raised-button',
  Stroked = 'mat-stroked-button',
  MiniFab = 'mat-mini-fab',
  Fab = 'mat-fab'
}

export enum TextSize {
  Small = 'mat-small'
}

export const DEFAULT_BUTTON_STYLE = ButtonStyle.Normal;
